import { FC, useMemo, useState } from 'react';

import { CONTACT_DEFAULT_MESSAGES, ICONS } from 'shared/presentation/constants';
import { useLocale } from 'shared/presentation/contexts';
import { selectRandomElementFromArray } from 'shared/presentation/helpers';
import { useTrackedWhatsappLink } from 'shared/presentation/hooks';

import * as S from './styles';

const IconX = ICONS.X;
const IconWhatsApp = ICONS.WHATSAPP;

const WhatsAppFloatingButton: FC = () => {
  const { language } = useLocale('shared');

  const message = useMemo(
    () => selectRandomElementFromArray(CONTACT_DEFAULT_MESSAGES[language]),
    [language],
  );

  const trackedLink = useTrackedWhatsappLink({
    event: 'clicou-botao-whats-principal',
    message,
  });

  const [shouldShowButton, setShouldShowButton] = useState<boolean>(true);

  if (!shouldShowButton) return null;

  return (
    <S.Container>
      <div>
        <button type="button" onClick={() => setShouldShowButton(false)}>
          <IconX />
        </button>

        <a
          href={trackedLink.href}
          target="_blank"
          rel="noopener noreferrer"
          onClick={trackedLink.onClickLink}
        >
          <IconWhatsApp />
        </a>
      </div>
    </S.Container>
  );
};

export default WhatsAppFloatingButton;
